// extracted by mini-css-extract-plugin
export default {"banner":"form-response_banner","success":"form-response_success","error":"form-response_error","heading":"form-response_heading","headingIcon":"form-response_headingIcon"};